import { Model } from '@vuex-orm/core';

// This model never really gets saved to the $store
export default class Payment extends Model {
  static entity = 'payments';

  static fields() {
    return {
      // id: this.attr(),
      ccName: this.string(),
      ccNumber: this.string(),
      ccExpiry: this.string(),
      ccYear: this.string(),
      ccMonth: this.string(),
      ccCVV: this.number(),

      // Stripe
      payment_method_id: this.string(),
      payment_intent_id: this.string(),

      voucher: this.string(),

      // Authorize
      firstName: this.number(),
      lastName: this.number(),
      phone: this.number(),

      address1: this.string(),
      address2: this.string(),
      city: this.string(),
      province: this.string(),
      postal: this.string(),
      country: this.string(),

      shippingAddress: this.string(),
      shippingCity: this.string(),
      shippingProvince: this.string(),
      shippingPostal: this.string(),
    };
  }
}